import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../landing-page/components/Footer';

const stepImages = [
  '/assets/images/clienti_step1_pubblica_richiesta.png',
  '/assets/images/clienti_step2_confronta_preventivi.png',
  '/assets/images/clienti_step3_scegli_professionista.png',
  '/assets/images/clienti_step4_lavoro_completato.png',
  '/assets/images/clienti_step5_lascia_recensione.png',
];

const steps = [
  {
    number: 1,
    title: 'Pubblica la richiesta',
    text: 'Spiega cosa ti serve in pochi minuti. Puoi aggiungere dettagli, foto e budget.',
    quote: 'Più sei preciso, più ricevi preventivi mirati.'
  },
  {
    number: 2,
    title: 'Ricevi e confronta i preventivi',
    text: 'I professionisti verificati ti inviano le loro proposte. Confronta prezzi, recensioni e profili in totale trasparenza.',
    quote: 'Tutto chiaro, in un colpo d\'occhio.'
  },
  {
    number: 3,
    title: 'Scegli il professionista',
    text: 'Seleziona quello che preferisci in base a qualità, prezzo e affidabilità.',
    quote: 'Decidi tu, senza pressioni.'
  },
  {
    number: 4,
    title: 'Il lavoro viene eseguito',
    text: 'Il professionista scelto esegue il lavoro concordato, tutto tracciato sulla piattaforma.',
    quote: 'Semplice, tracciato, senza sorprese.'
  },
  {
    number: 5,
    title: 'Valuta il professionista',
    text: 'Al termine del lavoro puoi lasciare una recensione e aiutare altri utenti a scegliere.',
    quote: 'La qualità crea fiducia.'
  }
];

const ComeFunzionaClientiPage = () => {
  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="w-full bg-card border-b border-border" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 24px', height: '64px' }}>
        <Link to="/">
          <img
            src="/assets/images/logoenometrasp-1775046870715.png"
            alt="Volaptic"
            style={{ height: '90px', width: 'auto' }}
          />
        </Link>
        <a
          href="/"
          className="text-sm text-muted-foreground hover:text-primary transition-colors duration-250 flex items-center gap-1">
          ← Home
        </a>
      </header>
      {/* Hero Image */}
      <div style={{ width: '100%', height: '400px', overflow: 'hidden' }}>
        <img
          src="/assets/images/clienti_hero_sfoglia_professionisti.png"
          alt="Proprietario di casa che sfoglia professionisti su laptop in un'abitazione italiana moderna"
          style={{ width: '100%', height: '400px', objectFit: 'cover', display: 'block' }}
        />
      </div>
      {/* Page Title */}
      <div className="max-w-4xl mx-auto px-4 md:px-6 pt-12 pb-4 text-center">
        <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-3">
          Come funziona per i Clienti
        </h1>
        <p className="text-muted-foreground text-lg">
          Cinque semplici passi per trovare il professionista giusto.
        </p>
      </div>
      {/* Steps */}
      <div className="max-w-5xl mx-auto px-4 md:px-6 py-10 flex flex-col gap-16 md:gap-20">
        {steps?.map((step, index) => {
          const isEven = index % 2 === 1;
          return (
            <div
              key={step?.number}
              className={`flex flex-col ${isEven ? 'md:flex-row-reverse' : 'md:flex-row'} items-center gap-8 md:gap-12`}>
              {/* Step Image */}
              <div className="flex-shrink-0 w-full md:w-auto flex justify-center">
                <img
                  src={stepImages?.[index]}
                  alt={step?.title}
                  style={{ maxWidth: '420px', width: '100%', height: '300px', borderRadius: '16px', objectFit: 'cover' }}
                  className="shadow-md"
                />
              </div>
              {/* Text */}
              <div className="flex flex-col gap-4 flex-1">
                <div className="flex items-center gap-3">
                  <span
                    className="flex-shrink-0 w-9 h-9 rounded-full bg-primary text-white flex items-center justify-center text-sm font-bold">
                    {step?.number}
                  </span>
                  <h2 className="text-xl md:text-2xl font-bold text-foreground">
                    {step?.title}
                  </h2>
                </div>
                <p className="text-muted-foreground text-base leading-relaxed">
                  {step?.text}
                </p>
                <p className="text-primary italic text-base font-medium border-l-4 border-primary pl-4">
                  "{step?.quote}"
                </p>
              </div>
            </div>
          );
        })}
      </div>
      {/* CTA */}
      <div className="w-full bg-card border-t border-border py-12 mt-4">
        <div className="max-w-xl mx-auto px-4 text-center flex flex-col items-center gap-4">
          <h2 className="text-2xl font-bold text-foreground">Pronto a iniziare?</h2>
          <p className="text-muted-foreground">
            Pubblica la tua richiesta e ricevi preventivi da professionisti verificati nella tua zona.
          </p>
          <Link to="/cliente/richiesta/nuova">
            <button
              style={{ backgroundColor: 'var(--color-primary)' }}
              className="text-white px-8 py-3 rounded-lg text-base font-semibold hover:opacity-90 transition-opacity mt-2">
              Pubblica la tua richiesta
            </button>
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ComeFunzionaClientiPage;
